import React from 'react';
import Icon from '../../icons';


const FormDecimal = (field) => {
    
return (
    <div className={`formGroup ${field.wrapperClass ? field.wrapperClass :''} ${(field.meta.touched && field.meta.error) ? 'errorMsg' : ''}`}>
        {field.label && <div className={`${field.labeldivclass}`}><label className={`${field.labelClass ? field.labelClass : ''} `}>{field.label}{field.isRequired && <sup>*</sup>}
            {field.helpText && <span className="quickTooltip-bottom" data-quicktooltip={field.helpText}><Icon name="info" className="icon ml greyInfoIcon" /></span>}
        </label></div>}
        <div className="wth-4">
        <input {...field.input} type="text" className={`${field.inputClass ? field.inputClass : ''} ${field.isDisabled ?"disabled":""}`}  maxLength={field.maxLength} onKeyUp={(e)=>{field.input.name.includes("finalindemnity_decimal") || field.input.name.includes("finalattorneyfees_decimal") ? field.onKeyUp(e) :null}} placeholder={field.placeholder} disabled={field.isDisabled}  normalize={field.normalize} autoFocus={field.autoFocus} />
        {field.meta.touched && field.meta.error &&
            <span>{field.meta.error}</span>}
        </div>
    </div>
)
}

export default FormDecimal;